import { defaultEntityLinkRouterHandler } from "helpers/routing/EntityLinkRouter/EntityLinkRouter.api.handler";

import { type IBrowseBuildertrendFilesConfig } from "commonComponents/btWrappers/editor/core/extensions/custom/image/ImageExtension";
import { type IStandardFeatureSetConfig } from "commonComponents/btWrappers/editor/core/extensions/ExtensionProvider.types";

/**
 * @param isExternalMode When true (anonymous share-link viewing), feature links render as plain
 * links instead of resolving via the authenticated-only default handler, which would otherwise
 * redirect anonymous viewers to login.
 * @param browseBuildertrendFilesConfig Only need to specify this if edit mode is supported, but this is used to enable upload
 * images from buildertrend files
 */
export const getSpecificationEditorConfig = (
    isExternalMode: boolean,
    browseBuildertrendFilesConfig: IBrowseBuildertrendFilesConfig | undefined = undefined,
): IStandardFeatureSetConfig => {
    const specificationConfig: IStandardFeatureSetConfig = {
        document: {
            extend: {
                content: "title block+",
            },
        },
        placeholder: {
            configure: {
                placeholder: ({ node, editor }) => {
                    if (node.type.name === "title") {
                        return "Add a title (Ex: 06 - Framing)";
                    } else if (
                        editor.state.doc.childCount <= 2 &&
                        node.type.name === "paragraph" &&
                        node.attrs.textAlign === null
                    ) {
                        return (
                            "Describe the scope of work and any requirements for this trade or division. " +
                            "This information helps crews understand expectations and complete the work correctly.\n\n" +
                            "Example:\n" +
                            "• Use SPF #2 lumber or better.\n" +
                            '• Frame exterior walls at 16" O.C. and interior walls at 24" O.C., unless noted otherwise.\n' +
                            "• Install LVL headers for openings 4' or wider, per structural plans.\n" +
                            "• Add solid blocking as needed for fixtures, cabinetry, handrails, and code compliance."
                        );
                    }
                    return "";
                },
            },
        },
        image: {
            configure: {
                browseBuildertrendFilesConfig,
            },
        },
        entityLink: {
            configure: {
                handler: isExternalMode ? undefined : defaultEntityLinkRouterHandler,
            },
        },
    };

    return specificationConfig;
};
